var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFossilHunting = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jc7bg4bu7a",
    d: "M0 0h21.922v17.217H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j1e0f961sc",
    d: "M.082 0h.216v.38H.082z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "72fvkb7nqe",
    d: "M.086 0h.208v.38H.086z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fwp74u1cxg",
    d: "M.085 0h.21v.38h-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qk09e125hi",
    d: "M.085 0h.21v.38h-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r9taxnl9ck",
    d: "M.085 0h.21v.38h-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dvjhxdx1cm",
    d: "M.085 0h.21v.38h-.21z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tuw9fcxk8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jc7bg4bu7a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.922 12.648c-.087.125-.053.273-.074.41-.06.397-.371.632-.784.566a2615.85 2615.85 0 0 1-4.406-.703c-.724-.115-1.448-.231-2.17-.352-.138-.023-.194.01-.24.144-.679 1.992-2.046 3.366-4.08 4.113-1.114.41-2.271.483-3.45.29-1.728-.284-3.21-1.02-4.428-2.225a7.522 7.522 0 0 1-2.074-3.688C-.228 9.31.026 7.478.84 5.73 2.153 2.909 4.384 1.086 7.503.299c1.722-.435 3.458-.385 5.158.08 4.82 1.32 7.814 4.347 9.001 9.02.12.473.178.957.218 1.442.002.032-.006.07.042.08v.164c-.026.023-.02.054-.022.082.001.03-.004.06.022.083v.288a.302.302 0 0 0 0 .246v.411c-.03.027-.02.062-.022.094v.1c.002.033-.008.068.022.094v.165z",
    fill: "#1C2333",
    mask: "url(#tuw9fcxk8b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.63 15.482)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iy988nvp9d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j1e0f961sc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.297.32C.233.235.23.147.297.06v.26z",
    fill: "#161616",
    mask: "url(#iy988nvp9d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.633 16.16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "91nymj7hlf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#72fvkb7nqe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.257.257v-.13C.27.106.282.104.295.125v.13C.282.274.27.275.257.257",
    fill: "#606060",
    mask: "url(#91nymj7hlf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.632 14.954)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3g16c1yjxh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fwp74u1cxg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.259.224C.254.188.242.15.295.139v.087C.282.246.27.246.26.224",
    fill: "#858585",
    mask: "url(#3g16c1yjxh)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.632 15.028)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k7472xcv1j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qk09e125hi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.259.145c.012 0 .024 0 .036.002v.088C.251.218.251.183.259.145",
    fill: "#626262",
    mask: "url(#k7472xcv1j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.633 16.059)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1dpu4o01xl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r9taxnl9ck"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.295.232.258.235C.251.197.254.163.295.145v.087z",
    fill: "#4A4A4A",
    mask: "url(#1dpu4o01xl)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.632 16.263)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qif8h575fn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dvjhxdx1cm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.258.148.295.146v.088C.244.222.253.184.258.148",
    fill: "#767676",
    mask: "url(#qif8h575fn)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.632 15.643c0 .158-.01.316.002.473.011.15-.043.186-.192.16-.632-.105-1.265-.204-1.897-.305-1.251-.2-2.501-.402-3.753-.595-.189-.029-.266-.067-.258-.285.045-1.21-.314-2.309-1.073-3.279-.108-.139-.102-.209.027-.33a424.102 424.102 0 0 0 3.435-3.302c.138-.135.2-.114.327.004 1.743 1.634 2.83 3.6 3.241 5.906.091.513.138 1.032.14 1.553M10.95 10.923c2.124-.011 3.896 1.428 4.236 3.256.05.27.077.541.08.816.003.118-.033.134-.147.114a64.03 64.03 0 0 0-1.476-.234c-.13-.019-.168-.065-.165-.196.04-1.475-1.126-2.629-2.656-2.629a2.2 2.2 0 0 0-1.308.44.592.592 0 0 0-.134.827c.196.273.58.374.866.163.698-.514 1.816.02 1.943.923.099.695-.378 1.476-1.07 1.757-1.065.432-2.373-.068-2.912-1.134-.504-.997-.296-1.94.337-2.805.633-.863 1.534-1.278 2.406-1.298M18.067 7.256c-.04.042-.082.088-.126.13-1.13 1.086-2.262 2.169-3.388 3.258-.103.1-.168.12-.294.03a5.206 5.206 0 0 0-1.99-.856c-.118-.025-.168-.07-.167-.201.006-1.398.004-2.796.003-4.193 0-.102-.012-.176.148-.167 2.128.13 4.063.777 5.795 1.974.006.004.009.011.02.025M10.823 5.314v.236c0 1.308-.003 2.617.004 3.925 0 .16-.022.24-.215.254a3.903 3.903 0 0 0-1.328.358c-.1.046-.16.035-.238-.04a663.58 663.58 0 0 0-2.737-2.63c-.078-.074-.091-.113.002-.189a8.697 8.697 0 0 1 4.512-1.914M3.348 12.606c.19-1.775 1.087-3.465 1.974-4.391.887.851 1.773 1.704 2.663 2.553.08.076.077.12 0 .192-.468.435-.81.95-1.04 1.533-.033.084-.069.133-.179.132-1.119-.004-2.238-.003-3.357-.004-.02 0-.04-.01-.06-.015M4.977 13.853c.506 0 1.013.003 1.52-.002.116-.001.16.026.161.146.002.777.256 1.476.735 2.1.06.081.063.131-.015.206-.63.597-1.254 1.198-1.877 1.801-.079.076-.121.076-.2-.001-1.159-1.145-1.827-2.507-1.983-4.1-.013-.124.018-.15.14-.15.506.007 1.012.003 1.519.003v-.003zM6.404 18.97c.662-.634 1.311-1.25 1.953-1.874.102-.098.167-.021.239.017a3.757 3.757 0 0 0 2.034.438c.396-.025.395-.024.489.341.141.55.278 1.102.432 1.65.042.149.005.192-.142.231-1.54.418-3.003.186-4.413-.485-.195-.093-.38-.204-.592-.318M12.774 19.175c-.185-.711-.36-1.393-.541-2.073-.025-.094-.005-.15.074-.208.286-.21.521-.465.706-.761.044-.07.09-.104.188-.088.567.097 1.136.186 1.705.274.086.014.126.028.09.128-.411 1.144-1.141 2.047-2.222 2.728",
    fill: "#FEFEFE"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFossilHunting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-fossil-hunting.697627cd.svg";
export { ForwardRef as ReactComponent };